import { render, staticRenderFns } from "./RoleLink.vue?vue&type=template&id=381877d3&scoped=true&"
import script from "./RoleLink.vue?vue&type=script&lang=js&"
export * from "./RoleLink.vue?vue&type=script&lang=js&"
import style0 from "./RoleLink.vue?vue&type=style&index=0&id=381877d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381877d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContainer,VContent})
